import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import Alert from "@mui/material/Alert";
import {
  getPromotionItems,
  listProducts,
} from "../../../../actions/productActions";
import "react-input-range/lib/css/index.css";
import BreadcrumbCom from "../../../BreadcrumbCom";
import ProductCardStyleOne from "../../../Helpers/Cards/ProductCardStyleOne";
import DataIteration from "../../../Helpers/DataIteration";
import Layout from "../../../Partials/Layout";
import ProductsFilter from "./ProductsFilter";
import LoadingBox from "../../../Helpers/Loaders/LoadingBox";
import IRGProductCardStyleOne from "../../../Helpers/Cards/IRGProductCardStyleOne";
import IRGAuthPopup from "../IRGPopup/IRGAuthPopup";

export default function AllIRGProductPage() {
  const { search } = useLocation();
  const redirectInUrl = new URLSearchParams(search).get("redirect");
  const redirect = redirectInUrl ? redirectInUrl : "/Login";

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const styleNumbers = [
    // IRG Edge
    "2801",
    "2803",
    "2811",
    "2851",
    "2861",
    "6801",
    "6802",
    "6803",
    "6851",
    "6852",
    // IRG Elevate
    "181001",
    "181002",
    "181003",
    "181201",
    "181202",
    "181203",
    "181501",
    "181502",
    // IRG Elite
    "3801",
    "3802",
    "3803",
    "3811",
    "3852",
    "7801",
    "7802",
    "7852",
    // IRG EPIC
    "4800",
    "4801",
    "4802",
    "4803",
    "4804",
    "4811",
    "4812",
    "4851",
    "4854",
    "9811",
    "9812",
    "9813",
    "9851",
    "9852",
    "4861",
    // IRG Marketing Materials
    "EPCBG2023",
    "EPCP2301",
    "EPCT2301",
    "IRGSAN2301",
    "IRGP2301",
    "IRGPP2024",
    "IRGT2301",
    "IRGCT2025",
    "IRGMA2025",
    "IRGTRI2025",
  ];

  const productList = useSelector((state) => state.getPromotionItems);

  const { loading, error, products } = productList;
  const [filters, setFilter] = useState({
    // gender
    Women: false,
    Men: false,
    Unisex: false,

    // garmentType
    Top: false,
    Pants: false,
    Jacket: false,

    // color
    BKM: false,
    BLK: false,
    CBL: false,
    CHC: false,
    HPK: false,
    HTR: false,
    KHI: false,
    MBL: false,
    NVY: false,
    NYM: false,
    PEW: false,
    PPL: false,
    RED: false,
    RYL: false,
    TEL: false,
    WHT: false,
    WIN: false,

    // fit
    Petite: false,
    Regular: false,
    Short: false,
    Tall: false,

    // size
    XXS: false,
    SM: false,
    XS: false,
    MD: false,
    LG: false,
    XL: false,
    twoXL: false,
    threeXL: false,
    fourXL: false,
    fiveXL: false,
    XSP: false,
    SMP: false,
    MDP: false,
    LGP: false,
    XLP: false,
    twoXLS: false,
    threeXLS: false,
    XST: false,
    SMT: false,
    MDT: false,
    LGT: false,
    XLT: false,
    threeXLT: false,

    // Inseam
    twofive: false,
    twosix: false,
    twoseven: false,
    twoeight: false,
    twoninedotfive: false,
    threeone: false,
    threethree: false,
  });
  const [volume, setVolume] = useState({ min: 0, max: 100 });
  const [price, setPrice] = useState({ min: 0, max: 100 });

  // ================================ IRG Authentication ==================================
  const [isIRGPopupOpen, setIsIRGPopupOpen] = useState(false);

  // Check IRGtoken
  const getIRGToken = () => {
    const IRGtoken = localStorage.getItem("IRGAccesstoken");
    const IRGtokenExpiry = localStorage.getItem("IRGtokenExpiry");

    if (!IRGtoken || !IRGtokenExpiry) return null;

    const now = new Date().getTime();
    if (now > IRGtokenExpiry) {
      localStorage.removeItem("IRGAccesstoken");
      localStorage.removeItem("IRGtokenExpiry");
      return null;
    }

    return IRGtoken;
  };

  // Redirect to home if token is invalid
  useEffect(() => {
    const IRGtoken = getIRGToken();
    if (!IRGtoken) {
      // If the user is not verified as a IRG member
      // window.location.href = "/";
      setIsIRGPopupOpen(true);
    }
  }, []);

  const correctPasscode = "E-prosper4!";
  const [showIRGError, setShowIRGError] = useState(false); // State for error message
  const [enteredIRGPasscode, setEnteredIRGPasscode] = useState("");
  const [passcodePass, setPasscodePass] = useState("hide-password");
  const [failedAttempts, setFailedAttempts] = useState(0); // Track failed attempts

  // Function to close the popup
  const closeIRGPopup = () => {
    setFailedAttempts(0);

    setIsIRGPopupOpen(false);
    setShowIRGError(false);
    setEnteredIRGPasscode(""); // Reset passcode input on close

    window.location.href = "/";
  };

  // Function to generate token with expiration and store in localStorage
  const generateTokenWithAutoClear = (expiryMinutes = 90) => {
    const IRGtoken = Math.random().toString(36).substring(2); // Simple token generator
    const IRGexpiryTime = new Date().getTime() + expiryMinutes * 60000;

    localStorage.setItem("IRGAccesstoken", IRGtoken);
    localStorage.setItem("IRGtokenExpiry", IRGexpiryTime);

    // Auto-clear token after expiration time
    setTimeout(() => {
      localStorage.removeItem("IRGAccesstoken");
      localStorage.removeItem("IRGtokenExpiry");
    }, expiryMinutes * 60000);

    return IRGtoken;
  };

  // Function to verify IRG passcode
  const verifyIRGPasscode = () => {
    // Step 1: Check if an existing valid token is already in local storage
    const hasIRGtoken = getIRGToken();
    if (!hasIRGtoken) {
      // Step 2 : Validate the entered password
      if (enteredIRGPasscode === correctPasscode) {
        // Step 3 : Reset failed attempts if passcode is correct
        setFailedAttempts(0);

        // Step 4 : Generate token with expiration
        generateTokenWithAutoClear(180);

        // Step 5 : Redirect to IRG page
        closeIRGPopup();
        window.location.href = "/Collection/IRGAll";
      } else {
        // If the password is incorrect, increment the failed attempts
        const newFailedAttempts = failedAttempts + 1;
        setFailedAttempts(newFailedAttempts);
        setShowIRGError(true); // Show error message
      }
    }
  };

  const showPasscode = (value) => {
    const password = document.getElementById(`${value}`);
    if (value && value === "entered_password") {
      if (password.type === "password") {
        password.type = "text";
        setPasscodePass("show-password");
      } else {
        password.type = "password";
        setPasscodePass("hide-password");
      }
    }
  };

  // =============================== validate logined user =========================================
  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo, userLoading, userError } = userSignin;

  // Check userToken and filtering
  useEffect(() => {
    if (!userInfo) {
      alert("Please sign in to access our website. ");

      // Remove IRG token
      localStorage.removeItem("IRGAccesstoken");
      localStorage.removeItem("IRGtokenExpiry");

      navigate(redirect);
    } else {
      console.log("You are already logined ");
    }

    /* Garment Type */
    let GarmentTypeURL = "";
    if (filters.Top) {
      GarmentTypeURL += "Top,";
    }
    if (filters.Pants) {
      GarmentTypeURL += "Pant,";
    }
    if (filters.Jacket) {
      GarmentTypeURL += "Jacket,";
    }
    if (GarmentTypeURL !== "") {
      GarmentTypeURL = GarmentTypeURL.substring(0, GarmentTypeURL.length - 1);
    }

    /* Gender */
    let genderURL = "";
    if (filters.Women) {
      genderURL += "Women,";
    }
    if (filters.Men) {
      genderURL += "Men,";
    }
    if (filters.Unisex) {
      genderURL += "Unisex,";
    }
    if (genderURL !== "") {
      genderURL = genderURL.substring(0, genderURL.length - 1);
    }

    /* Fit */
    let fitURL = "";
    if (filters.Petite) {
      fitURL += "Petite,";
    }
    if (filters.Regular) {
      fitURL += "Reg,";
    }
    if (filters.Short) {
      fitURL += "Short,";
    }
    if (filters.Tall) {
      fitURL += "Tall,";
    }
    if (fitURL !== "") {
      fitURL = fitURL.substring(0, fitURL.length - 1);
    }

    /* Size */
    /* Regular */
    let sizeURL = "";
    if (filters.XXS) {
      sizeURL += "XXS,";
    }
    if (filters.SM) {
      sizeURL += "SM,";
    }
    if (filters.XS) {
      sizeURL += "XS,";
    }
    if (filters.MD) {
      sizeURL += "MD,";
    }
    if (filters.LG) {
      sizeURL += "LG,";
    }
    if (filters.XL) {
      sizeURL += "XL,";
    }
    if (filters.twoXL) {
      sizeURL += "2XL,";
    }
    if (filters.threeXL) {
      sizeURL += "3XL,";
    }
    if (filters.fourXL) {
      sizeURL += "4XL,";
    }
    if (filters.fiveXL) {
      sizeURL += "5XL,";
    }
    /* Petite */
    if (filters.XSP) {
      sizeURL += "XSP,";
    }
    if (filters.SMP) {
      sizeURL += "SMP,";
    }
    if (filters.MDP) {
      sizeURL += "MDP,";
    }
    if (filters.LGP) {
      sizeURL += "LGP,";
    }
    if (filters.XLP) {
      sizeURL += "XLP,";
    }
    if (filters.twoXLP) {
      sizeURL += "2XLP,";
    }
    if (filters.threeXLP) {
      sizeURL += "3XLP,";
    }
    /* Short */
    if (filters.XSS) {
      sizeURL += "XSS,";
    }
    if (filters.SMS) {
      sizeURL += "SMS,";
    }
    if (filters.MDS) {
      sizeURL += "MDS,";
    }
    if (filters.LGS) {
      sizeURL += "LGS,";
    }
    if (filters.XLS) {
      sizeURL += "XLS,";
    }
    if (filters.twoXLS) {
      sizeURL += "2XLS,";
    }
    if (filters.threeXLS) {
      sizeURL += "3XLS,";
    }
    /* Tall */
    if (filters.XST) {
      sizeURL += "XST,";
    }
    if (filters.SMT) {
      sizeURL += "SMT,";
    }
    if (filters.MDT) {
      sizeURL += "MDT,";
    }
    if (filters.LGT) {
      sizeURL += "LGT,";
    }

    if (filters.XLT) {
      sizeURL += "XLT,";
    }
    if (filters.twoXLT) {
      sizeURL += "2XLT,";
    }
    if (filters.threeXLT) {
      sizeURL += "3XLT,";
    }
    if (sizeURL !== "") {
      sizeURL = sizeURL.substring(0, sizeURL.length - 1);
    }

    /* Insaem Length */
    let inseamURL = "";
    if (filters.twofive) {
      inseamURL += "25,";
    }
    if (filters.twosix) {
      inseamURL += "26,";
    }
    if (filters.twoseven) {
      inseamURL += "27,";
    }
    if (filters.twoeight) {
      inseamURL += "28,";
    }
    if (filters.twoninedotfive) {
      inseamURL += "29.5,";
    }
    if (filters.threeone) {
      inseamURL += "31,";
    }
    if (filters.threethree) {
      inseamURL += "33,";
    }
    if (inseamURL !== "") {
      inseamURL = inseamURL.substring(0, inseamURL.length - 1);
    }

    /* Price */
    let priceFromURL = "";
    if (price.min || price.min === 0) {
      priceFromURL += price.min.toString();
    }
    let priceToURL = "";
    if (price.max || price.max === 0) {
      priceToURL += price.max.toString();
    }

    /* Color */
    let colorURL = "";
    if (filters.BKM) {
      colorURL += "BKM,";
    }
    if (filters.BLK) {
      colorURL += "BLK,";
    }
    if (filters.CBL) {
      colorURL += "CBL,";
    }
    if (filters.CHC) {
      colorURL += "CHC,";
    }
    if (filters.HPK) {
      colorURL += "HPK,";
    }
    if (filters.HTR) {
      colorURL += "HTR,";
    }
    if (filters.KHI) {
      colorURL += "KHI,";
    }
    if (filters.MBL) {
      colorURL += "MBL,";
    }
    if (filters.NVY) {
      colorURL += "NVY,";
    }
    if (filters.NYM) {
      colorURL += "NYM,";
    }
    if (filters.PEW) {
      colorURL += "PEW,";
    }
    if (filters.PPL) {
      colorURL += "PPL,";
    }
    if (filters.RED) {
      colorURL += "RED,";
    }
    if (filters.RYL) {
      colorURL += "RYL,";
    }
    if (filters.TEL) {
      colorURL += "TEL,";
    }
    if (filters.WHT) {
      colorURL += "WHT,";
    }
    if (filters.WIN) {
      colorURL += "WIN,";
    }
    if (colorURL !== "") {
      console.log(colorURL);

      colorURL = colorURL.substring(0, colorURL.length - 1);
    }

    // dispatch(getPromotionItems(styleNumbers));
    dispatch(
      getPromotionItems({
        styleNumbers,
        gender: genderURL,
        GarmentType: GarmentTypeURL,
        fit: fitURL,
        size: sizeURL,
        inseam: inseamURL,
        color: colorURL,
        priceFrom: priceFromURL,
        priceTo: priceToURL,
      })
    );
  }, [dispatch, filters, price, navigate, redirect, userInfo]);

  const checkboxHandler = (e) => {
    const { name } = e.target;

    setFilter((prevState) => ({
      ...prevState,
      [name]: !prevState[name],
    }));
  };

  const volumeHandler = (e) => {
    setVolume(e);
  };

  const priceHandler = () => {
    setPrice(volume);
  };

  const [storage, setStorage] = useState(null);
  const filterStorage = (value) => {
    setStorage(value);
  };
  const [filterToggle, setToggle] = useState(false);
  const [activeButton, setActiveButton] = useState(null);

  // Extract the button type from the current URL path
  useEffect(() => {
    const path = location.pathname.split("/")[2]; // Assuming the type is the third segment in /Collection/{type}
    console.log("path", path);
    if (path === "IRGAll") {
      setActiveButton("All Products");
    } else {
      setActiveButton(path);
    }
  }, [location.pathname]);

  // Redirect to the constructed URL
  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
    if (buttonName === "All Products") {
      navigate("/Collection/IRGAll");
    } else if (buttonName === "EPIC") {
      navigate(`/Collection/${buttonName}`);
    } else if (buttonName === "EDGE") {
      navigate(`/Collection/${buttonName}`);
    } else if (buttonName === "Elevate") {
      navigate(`/Collection/${buttonName}`);
    } else if (buttonName === "Elite") {
      navigate(`/Collection/${buttonName}`);
    } else if (buttonName === "Marketing Materials") {
      navigate(`/Collection/MarketingMaterials`);
    }
  };

  return (
    <>
      <Layout>
        <div className="products-page-wrapper w-full">
          <div className="container-x mx-auto">
            <BreadcrumbCom />
            {/* IRG passcode window */}
            {isIRGPopupOpen && (
              <IRGAuthPopup
                isOpen={isIRGPopupOpen}
                closePopup={closeIRGPopup}
                verifyPasscode={verifyIRGPasscode}
                failedAttempts={failedAttempts}
                showError={showIRGError}
                setPasscode={setEnteredIRGPasscode}
                passcodeValue={enteredIRGPasscode}
                togglePasscodeVisibility={showPasscode}
                passcodeVisibility={passcodePass}
              />
            )}

            {/* Collection Banner */}
            <div className="breadcrumb-wrapper font-400 text-[13px] text-qblack mb-[23px]">
              {/* <Link to="/IRG/Elite">   */}
              <img
                // src="https://maevn-images.s3.us-east-2.amazonaws.com/banners/2024-12-05/B2B_Collection_Banner_2000x500_EXTRA.jpg"
                src="https://maevn-images.s3.us-east-2.amazonaws.com/banners/2024-11-26/IRGAll_m1_SP25.jpg"
                alt="Collection"
                style={{ width: "100%", height: "auto" }}
              />
              {/* </Link>  */}
            </div>
            <div className="w-full lg:flex lg:space-x-[30px]">
              {/* filter */}
              <div className="lg:w-[270px]">
                <ProductsFilter
                  filterToggle={filterToggle}
                  filterToggleHandler={() => setToggle(!filterToggle)}
                  filters={filters}
                  checkboxHandler={checkboxHandler}
                  volume={volume}
                  volumeHandler={volumeHandler}
                  priceHandler={priceHandler}
                  storage={storage}
                  filterstorage={filterStorage}
                  className="mb-[30px]"
                />
              </div>
              <div className="flex-1">
                <div className="products-sorting w-full bg-white md:h-[70px] flex md:flex-row flex-col md:space-y-0 space-y-5 md:justify-between md:items-center p-[30px] mb-[40px]">
                  {/* collectioin button container */}
                  <div className="IRG-button-container">
                    <button
                      type="button"
                      className={
                        activeButton === "All Products" ? "active-button" : ""
                      }
                      onClick={() => handleButtonClick("All Products")}
                    >
                      All Products
                    </button>
                    <button
                      type="button"
                      className={activeButton === "EPIC" ? "active-button" : ""}
                      onClick={() => handleButtonClick("EPIC")}
                    >
                      EPIC
                    </button>
                    <button
                      type="button"
                      className={activeButton === "EDGE" ? "active-button" : ""}
                      onClick={() => handleButtonClick("EDGE")}
                    >
                      EDGE
                    </button>
                    <button
                      type="button"
                      className={
                        activeButton === "Elevate" ? "active-button" : ""
                      }
                      onClick={() => handleButtonClick("Elevate")}
                    >
                      Elevate
                    </button>
                    <button
                      type="button"
                      className={
                        activeButton === "Elite" ? "active-button" : ""
                      }
                      onClick={() => handleButtonClick("Elite")}
                    >
                      Elite
                    </button>
                    <button
                      type="button"
                      className={
                        activeButton === "MarketingMaterials"
                          ? "active-button"
                          : ""
                      }
                      onClick={() => handleButtonClick("Marketing Materials")}
                    >
                      Marketing Materials
                    </button>
                  </div>

                  <div>
                    <p className="font-400 text-[13px]">
                      <span className="text-qgray">Showing</span>{" "}
                      {/*   {products && products.length !== 0
                        ? products.data.result.length
                        : 0}{" "}
                        */}
                      {products && products.length > 0 ? products.length : 0}{" "}
                      results
                    </p>
                  </div>

                  <button
                    onClick={() => setToggle(!filterToggle)}
                    type="button"
                    className="w-10 lg:hidden h-10 rounded flex justify-center items-center border border-qyellow text-qyellow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                      />
                    </svg>
                  </button>
                </div>

                <div className="grid xl:grid-cols-3 sm:grid-cols-2 grid-cols-1  xl:gap-[30px] gap-5 mb-[40px]">
                  <>
                    {loading && <LoadingBox />}
                    {products && products.length !== 0 ? (
                      <DataIteration
                        datas={products}
                        startLength={0}
                        endLength={products.length}
                      >
                        {({ datas }) => (
                          <div data-aos="fade-up" key={datas.id}>
                            {/* <ProductCardStyleOne datas={datas} /> */}
                            <IRGProductCardStyleOne datas={datas} />
                          </div>
                        )}
                      </DataIteration>
                    ) : (
                      // Handling for when there are no products or filtering results in an empty list
                      <DataIteration
                        datas={products}
                        startLength={0}
                        endLength={0}
                      >
                        {/* Empty component */}
                        {({ datas }) => (
                          <div data-aos="fade-up" key={datas.id}>
                            <IRGProductCardStyleOne datas={datas} />
                            {/* You can insert an empty state component or message here */}
                          </div>
                        )}
                      </DataIteration>
                    )}
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
      }
    </>
  );
}
